import React from 'react';
import MainContainer from '../components/layout/MainContainer';
import CreateNewMold from '../components/CreateNewMold';
import { TopbarBackgroundStyle } from '@/components/layout/EnhancedModernTopbar';

interface CreateMoldContainerProps { }

const CreateMoldContainer: React.FC<CreateMoldContainerProps> = () => {
  return (
    <MainContainer title="เพิ่มข้อมูลแม่พิมพ์ใหม่" topbarBackgroundStyle={TopbarBackgroundStyle.BLUE_GRADIENT}>
      <CreateNewMold />
    </MainContainer>
  )
};

export default CreateMoldContainer;
